import PublicHeader from "../../components/PublicHeader"
import HeaderImg from "../../assets/images/About_us.jpg"
import { Box, Typography } from "@mui/material";
import CustomTimeLine from "../../components/TimeLine/CustomTimeLine";
import Seo from "../../components/Seo/Seo";
const AboutUs = () => {
    return (
        <>
          <Seo
            title="About Us | JB Architects & Engineers, Tirunelveli"
            description="Founded in 2018, JB Architects & Engineers is a trusted architectural firm in Tirunelveli and Palayamkottai, blending architectural design, space planning and structural coordination with technical expertise."
            keywords={[
              "architects in tirunelveli",
              "engineers and architects in tirunelveli",
              "top architects consultant in tirunelveli",
              "architecture and engineering firm near me",
            ]}
            path="/about-us"
          />
          <PublicHeader name="About Us" image={HeaderImg}/>
          <div className="p-4">
            {/* introduction */}
            <Box>
              <Typography variant="h5" color="orange">
                  Introduction
              </Typography>
              <Typography variant="p"  padding="10px" >
                  We are a forward-thinking architecture and engineering firm dedicated to shaping spaces that inspire, 
                  innovate, and endure. From concept to completion, we bring visions to life with precision, creativity, 
                  and sustainability.
              </Typography>
            </Box>
            {/* who we are */}
            <Box marginTop="20px">
              <Typography variant="h5" color="orange">
                  Who We Are
              </Typography>
              <Typography variant="p"  padding="10px">
                Founded in 2018, JB Architects and Engineers has grown into a
                trusted name in architecture and engineering, blending artistry
                with technical expertise. Our team of architects, engineers, and
                project managers collaborates seamlessly to deliver outstanding
                results.
              </Typography>
            </Box>
            {/* who we are */}
            <Box marginTop="20px">
              <Typography variant="h5" color="orange">
                Our Mission
              </Typography>
              <Typography variant="p"  padding="10px">
                To craft environments that are not only aesthetically stunning but also structurally sound, 
                sustainable, and community-centered
              </Typography>
            </Box>
            
            {/* who we are */}
            <Box marginTop="20px">
              <Typography variant="h5" color="orange" textAlign="center">
                Our Process
              </Typography>
              <CustomTimeLine/>
            </Box>
          </div>
        </>
    )
}

export default AboutUs;